import { fromLonLat } from 'ol/proj'

export function parseConfig(elId){
    let config = {
        center: fromLonLat([-79.41411, 46.31588]),
        zoom: 12,
        sources: [],
        basemap: 'cnb'
    };

    //parse the config element
    var mapEl = document.getElementById(elId);
    var mapConfigEls = mapEl.getElementsByTagName('config');
    if(mapConfigEls.length == 1){
        const configEl = mapConfigEls[0];
        
        // extract center and zoom
        const centerParam = configEl.getAttribute('center');
        const zoomParam = configEl.getAttribute('zoom');
        if(centerParam !== null){
            var center = fromLonLat(JSON.parse(centerParam));
            console.log('center is ', center);
            config.center = center;
        }
        if(zoomParam !== null){
            config.zoom = zoomParam;
        }

        // extract basemap
        const basemap = configEl.getAttribute('basemap');
        if(basemap !== null){
            config.basemap = basemap;
        }

        // extract the sources
        const sourcesEls = configEl.getElementsByTagName('sources');
        if(sourcesEls.length == 1){
            const sourcesEl = sourcesEls[0].getElementsByTagName('data-source');
            for(let sourceEl of sourcesEl){
                const type = sourceEl.getAttribute('type');
                if(type == 'geoJSONSource'){
                    var source = parseGeoJSONSource(sourceEl);
                    config.sources.push(source);
                }
            }
        }
    }

    return config;
}

function parseGeoJSONSource(sourceEl){
    const type = sourceEl.getAttribute('type');
    const url = sourceEl.getAttribute('url');
    const styleProperty = sourceEl.getAttribute('style-property');
    const styleName = sourceEl.getAttribute('style-name');
    let source = {
        type: type,
        url: url,
        styleProperty: styleProperty,
        styleName: styleName,
        styles: {},
        select: {
            title:null,
            fields: []
        }
    };
    
    //parse the style config
    var els = sourceEl.getElementsByTagName('style-map');
    if(els.length == 1){
        els = els[0].getElementsByTagName('map');
        for(let el of els){
            source.styles[el.getAttribute('name')] = {
                fill : el.getAttribute('fill'),
                stroke : el.getAttribute('stroke'),
                width : el.getAttribute('width')
            };
        }
    }

    //parse the selected-feature config
    els = sourceEl.getElementsByTagName('select-feature');
    if(els.length == 1){
        source.select.title = els[0].getAttribute('title');
        els = els[0].getElementsByTagName('feature-info');
        for(let el of els){
            source.select.fields.push({
                property: el.getAttribute('property'),
                label: el.getAttribute('label'),
                propertyType: el.getAttribute('propertyType')
            })
            // source.select.fields[el.getAttribute('property')] = el.getAttribute('label');
        }
    }
    
    return source;
}

